import React from 'react';
import './ModalConfirmacion.css';

interface ModalConfirmacionProps {
  visible: boolean;
  titulo: string;
  mensaje: string;
  onConfirmar: () => void;
  onCancelar: () => void;
  cargando?: boolean;
}

const ModalConfirmacion: React.FC<ModalConfirmacionProps> = ({
  visible,
  titulo,
  mensaje,
  onConfirmar,
  onCancelar,
  cargando = false,
}) => {
  if (!visible) return null;

  const manejarClickOverlay = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && !cargando) {
      onCancelar();
    }
  };

  return (
    <div className="modal-overlay" onClick={manejarClickOverlay}>
      <div className="modal-confirmacion">
        <div className="modal-confirmacion-header">
          <i className="fas fa-exclamation-triangle modal-icono-advertencia"></i>
          <h3>{titulo}</h3>
        </div>
        <div className="modal-confirmacion-body">
          <p>{mensaje}</p>
        </div>
        <div className="modal-confirmacion-footer">
          <button
            className="btn-modal btn-cancelar"
            onClick={onCancelar}
            disabled={cargando}
          >
            Cancelar
          </button>
          <button
            className="btn-modal btn-eliminar"
            onClick={onConfirmar}
            disabled={cargando}
          >
            {cargando ? (
              <>
                <span className="btn-spinner"></span>
                Eliminando...
              </>
            ) : (
              'Eliminar'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmacion;
